import { render, staticRenderFns } from "./BrProgress.vue?vue&type=template&id=689fc0f8&scoped=true"
import script from "./BrProgress.vue?vue&type=script&lang=js"
export * from "./BrProgress.vue?vue&type=script&lang=js"
import style0 from "./BrProgress.vue?vue&type=style&index=0&id=689fc0f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689fc0f8",
  null
  
)

export default component.exports